import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'fallbackClosingHours',
  initialState: null as null | string,
  reducers: {
    setFallbackClosingHours(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFallbackClosingHours } = slice.actions;

export default slice.reducer;
